import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const thinkstCanary = defineConnector({
  identifier: "thinkstCanary",
  name: "Thinkst Canary",
  tagLine: "Honeypot-based intrusion detection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.canary\\.tools/api/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Canary-Auth-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your console domain and auth token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Thinkst Canary](https://canary.tools/) console. Navigate to the gear icon and select **Global settings → API**. Copy your **auth token** and note your console domain (the `DOMAIN` part of `DOMAIN.canary.tools`).",
        },
      ],
    },
    {
      title: "Copy and paste the auth token into the field below",
      items: [
        {
          kind: "input",
          label: "Auth token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: `https://ping.canary.tools/api/v1/ping`,
    }),
  },
});
